/* Catalogue en ligne : le contenu arrive rendu par Liquid, en lecture continue (lisible sans script et sur mobile).
   Sur un écran assez large, ce script le range en pages A4 comme le catalogue PDF : chaque rubrique ouvre une page
   avec son bandeau, chaque produit est posé tant qu'il tient, un tableau trop long passe à la page suivante (« suite »).
   Toutes les mesures sont en % de la largeur de page : la mise en pages ne dépend pas de la taille de l'écran. */
(function () {
  var root = document.querySelector('[data-cv]');
  if (!root) return;
  var flow = root.querySelector('.cv-flow'), out = root.querySelector('.cv-pages');
  var LARGE = window.matchMedia('(min-width: 750px)');
  var pied = root.dataset.pied || '', titre = root.dataset.titre || '';
  var source = flow.innerHTML, built = false, n = 0;

  function page(cls) {
    var p = document.createElement('div');
    p.className = 'cv-page ' + (cls || '');
    out.appendChild(p);
    n++;
    p.id = 'cv-page-' + n;
    return p;
  }
  function num(p) {
    var s = document.createElement('span');
    s.className = 'cv-pnum ' + (n % 2 ? 'l' : 'r');
    s.textContent = n;
    p.appendChild(s);
  }
  function foot(p) {
    var f = document.createElement('div');
    f.className = 'cv-ft';
    f.innerHTML = '<span></span><span></span>';
    f.firstChild.textContent = titre;
    f.lastChild.textContent = pied;
    p.appendChild(f);
  }
  function over(body) { return body.scrollHeight > body.clientHeight + 1; }
  function rows(blk) { return [].slice.call(blk.querySelectorAll('.cv-mx[data-main] > tbody > tr')); }

  // découpe un produit trop haut : garde les premières lignes, renvoie la suite (ou null si une ligne ne tient même pas)
  function split(blk, body) {
    var rs = rows(blk), k = rs.length;
    if (k < 2) return null;
    var opt = blk.querySelector('[data-opt]');
    if (opt) opt.hidden = true;
    while (k > 1 && over(body)) { k--; rs[k].hidden = true; }
    if (over(body)) { rs.forEach(function (r) { r.hidden = false; }); if (opt) opt.hidden = false; return null; }
    var rest = blk.cloneNode(true);
    rest.removeAttribute('id');
    rest.classList.add('is-suite');
    var th = rest.querySelector('.cv-lft');
    if (th) th.remove();
    rest.classList.add('mod');
    rows(rest).forEach(function (r, i) { r.hidden = i < k; });
    rs.forEach(function (r, i) { if (i >= k) r.remove(); });
    rows(rest).forEach(function (r) { if (r.hidden) r.remove(); });
    if (opt) { opt.remove(); var o2 = rest.querySelector('[data-opt]'); if (o2) o2.hidden = false; }
    return rest;
  }

  function build() {
    out.innerHTML = '';
    n = 0;
    var tmp = document.createElement('div');
    tmp.innerHTML = source;
    [].forEach.call(tmp.children, function (el) {
      if (el.matches('.cv-sep, .cv-cover, .cv-toc')) {
        var p = page(el.className);
        p.innerHTML = el.innerHTML;
        if (el.id) { p.id = el.id; }
        if (el.matches('.cv-toc')) num(p);
        return;
      }
      if (!el.matches('.cv-sec')) return;
      var tr = el.querySelector('.cv-tr'), items = [].slice.call(el.querySelectorAll(':scope > .cv-blk'));
      var p = page('op'), body;
      p.id = el.id;
      p.appendChild(tr);
      body = document.createElement('div');
      body.className = 'cv-body';
      p.appendChild(body);
      foot(p); num(p);
      while (items.length) {
        var it = items.shift();
        body.appendChild(it);
        if (!over(body)) continue;
        if (body.children.length > 1) {
          body.removeChild(it);
          p = page(); body = document.createElement('div'); body.className = 'cv-body'; p.appendChild(body); foot(p); num(p);
          body.appendChild(it);
          if (!over(body)) continue;
        }
        var rest = split(it, body);
        if (rest) items.unshift(rest);
        if (items.length) { p = page(); body = document.createElement('div'); body.className = 'cv-body'; p.appendChild(body); foot(p); num(p); }
      }
    });
    ids(true);
    root.classList.add('is-paged');
    built = true;
    if (location.hash) { var t = document.getElementById(location.hash.slice(1)); if (t) t.scrollIntoView(); }
  }
  // les ancres (#salon-canapes…) doivent viser les pages : on retire les id de la lecture continue tant qu'elle est masquée
  function ids(off) {
    [].forEach.call(flow.querySelectorAll(off ? '[id]' : '[data-cv-id]'), function (el) {
      if (off) { el.setAttribute('data-cv-id', el.id); el.removeAttribute('id'); }
      else { el.id = el.getAttribute('data-cv-id'); el.removeAttribute('data-cv-id'); }
    });
  }
  function unbuild() {
    ids(false);
    out.innerHTML = '';
    root.classList.remove('is-paged');
    built = false;
  }

  // vue page par page ou double page, mémorisée par visiteur
  var vue = '1';
  try { vue = localStorage.getItem('cv-vue') || '1'; } catch (e) {}
  function setVue(v) {
    vue = v;
    out.classList.toggle('is-double', v === '2');
    [].forEach.call(root.querySelectorAll('[data-cv-vue]'), function (b) { b.setAttribute('aria-pressed', b.dataset.cvVue === v); });
    try { localStorage.setItem('cv-vue', v); } catch (e) {}
  }
  root.addEventListener('click', function (e) { var b = e.target.closest('[data-cv-vue]'); if (b) setVue(b.dataset.cvVue); });
  setVue(vue);

  // PDF : le navigateur enregistre les pages A4 (feuille d'impression dans catalogue.css). Sur mobile, on range
  // d'abord en pages, on charge toutes les images, puis on rend la lecture continue après l'impression.
  function eager() { [].forEach.call(out.querySelectorAll('img[loading="lazy"]'), function (i) { i.loading = 'eager'; }); }
  var pdf = root.querySelector('[data-cv-pdf]');
  if (pdf) pdf.addEventListener('click', function () {
    if (pdf.disabled) return;
    var label = pdf.textContent;
    pdf.disabled = true;
    pdf.textContent = pdf.dataset.attente || label;
    if (!built) build();
    eager();
    var imgs = [].slice.call(out.querySelectorAll('img'));
    Promise.all(imgs.map(function (i) {
      return i.complete ? 0 : new Promise(function (r) { i.addEventListener('load', r); i.addEventListener('error', r); });
    })).then(function () {
      pdf.disabled = false;
      pdf.textContent = label;
      window.print();
    });
  });
  // repère les parents des pages : la feuille d'impression masque tout le reste du site (header, pied, fenêtres)
  for (var a = out.parentElement; a && a !== document.body; a = a.parentElement) a.setAttribute('data-cv-chemin', '');
  window.addEventListener('beforeprint', eager);
  window.addEventListener('afterprint', function () { go(); });

  function go() { if (LARGE.matches && !built) build(); else if (!LARGE.matches && built) unbuild(); }
  var ready = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
  ready.then(go);
  (LARGE.addEventListener ? LARGE.addEventListener('change', go) : LARGE.addListener(go));
})();
